export const AuditorList = [
    {
        employeeId: -1,
        name: "Select an auditor"
    },
    {
        employeeId: 0,
        name: "All Auditors"
    },
    {
        employeeId: 134599,
        name: "Caroline Paras"
    },
    {
        employeeId: 526100,
        name: "Chloe Rosette"
    },
    {
        employeeId: 501983,
        name: "Daniel Juffre"
    },
    {
        employeeId: 606252,
        name: "Ryan Wilburn"
    },
    {
        employeeId: 572056,
        name: "Sarabeth McClain"
    },
    {
        employeeId: 310629,
        name: "Michael Joyce"
    },
    {
        employeeId: 410838,
        name: "Sheila Cole"
    }
]

export default AuditorList